import React from 'react';
import { ClientRolesConfig } from '../../client_configuration';
import type { ClientFormData } from '../utilities/formDataUtils';
import type { Role } from '@/types';
import type { ValidationError } from '@/utils/validation/types';

interface RolesStepProps {
  formData: ClientFormData;
  onRolesChange: (newRoles: Role[]) => void;
  isCustomized: boolean;
  onRevert: () => void;
  userDefaultRoles?: Role[];
  errors: ValidationError[];
  touchedFields: Set<string>;
  onValidityChange: (isValid: boolean) => void;
  clientName?: string;
  // DayRateConfig props
  handleChange: (field: keyof ClientFormData, value: ClientFormData[keyof ClientFormData]) => void;
  handleSwitchChange: (field: keyof ClientFormData, checked: boolean) => void;
  onFieldBlur: (field: keyof ClientFormData) => void;
  isLoading: boolean;
  isDayRateCustomized: boolean;
  onRevertDayRate: () => void;
}

const RolesStepComponent: React.FC<RolesStepProps> = ({
  formData,
  onRolesChange,
  isCustomized,
  onRevert,
  userDefaultRoles,
  errors,
  touchedFields,
  onValidityChange,
  clientName,
  handleChange,
  handleSwitchChange,
  onFieldBlur,
  isLoading,
  isDayRateCustomized,
  onRevertDayRate,
}) => {
  return (
    <div className="space-y-6">
      <ClientRolesConfig
        formData={formData}
        onRolesChange={onRolesChange}
        isCustomized={isCustomized}
        onRevert={onRevert}
        userDefaultRoles={userDefaultRoles}
        errors={errors}
        touchedFields={touchedFields}
        onValidityChange={onValidityChange}
        clientName={clientName}
        handleChange={handleChange}
        handleSwitchChange={handleSwitchChange}
        onFieldBlur={onFieldBlur}
        isLoading={isLoading}
        isDayRateCustomized={isDayRateCustomized}
        onRevertDayRate={onRevertDayRate}
      />
    </div>
  );
};

export const RolesStep = React.memo(RolesStepComponent);
